import React from 'react';
import { Spinner } from 'reactstrap';
import { Chart } from 'react-google-charts';

const SimpleBars = ({ values, height }) => {
  const real = values[0] || 0;
  const script = values[1];
  const score = (real / script) * 100;

  let color;
  if (score > 80) {
    color = '#89AAFD';
  } else if (score > 60) {
    color = '#f3c51f';
  } else {
    color = '#E57373';
  }

  return (
    <div className="w-100">
      <h6 className="m-0 text-left">Word Count:</h6>
      <div style={{ height }}>
        <Chart
          width="100%"
          height="100%"
          chartType="BarChart"
          loader={(
            <div>
              <Spinner type="grow" className="me-3" />
              Loading Chart
            </div>
          )}
          data={[
            ['Word Count', 'Count', { role: 'annotation' }, { role: 'style' }],
            ['Spoken', real, real, color],
            ['Script', script, script, '#5B67BA'],
          ]}
          options={{
            chartArea: { width: '50%' },
            legend: { position: 'none' },
            enableInteractivity: false,
            hAxis: {
              minValue: 0,
            },
          }}
        />
      </div>
    </div>
  );
};

export default SimpleBars;
